import React from "react";
import {
  EnvironmentCopyPageContent,
  EnvironmentCopyPageStateProvider,
} from ".";

export const EnvironmentCopyPage = () => {
  return (
    <>
      <EnvironmentCopyPageStateProvider>
        <EnvironmentCopyPageContent></EnvironmentCopyPageContent>
      </EnvironmentCopyPageStateProvider>
    </>
  );
};
